import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./Manufacturing.css";

const Manufacturing = () => {
  const navigate = useNavigate();

  // Card data with slugs for EMS page navigation
  const cardData = [
    {
      id: 1,
      slug: "pcb-assembly",  // ← Slug for EMS page
      icon: "🔧",
      title: "PCB Assembly",
      desc: "Leveraging advanced Surface-Mount Technology (SMT) and through-hole techniques, we deliver high-precision PCB assemblies. Our ISO9001-certified processes ensure reliability for automotive, medical, and consumer electronics.",
      accent: "#065f46",
    },
    {
      id: 2,
      slug: "turnkey-assembly",  // ← Slug for EMS page
      icon: "🔌",
      title: "Turnkey Assembly",
      desc: "BIBA Electronics offers a comprehensive turnkey solution, integrating advanced PCB assembly, custom TFT/LCD display design, BOM procurement, and system integration. Rapid prototyping and rigorous testing deliver tailored solutions.",
      accent: "#065f46",
    },
    {
      id: 3,
      slug: "consigned-assembly",  // ← Slug for EMS page
      icon: "📦",
      title: "Consigned Assembly",
      desc: "With Consigned PCB Assembly, you supply parts and components while BIBA handles fabrication and assembly. This flexible model ensures high-quality boards built to meet your exact application requirements and specifications.",
      accent: "#065f46",
    },
  ];

  // Navigate to EMS page with service slug
  const handleCardClick = (serviceSlug) => {
    navigate(`/ems?service=${serviceSlug}`);
  };

  // Animation variants
  const fadeUp = {
    hidden: { opacity: 0, y: -22 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  const ornAnim = {
    hidden: { opacity: 0, scaleX: 0 },
    visible: { opacity: 1, scaleX: 1, transition: { duration: 0.7, delay: 0.35, ease: "easeOut" } },
  };

  return (
    <section className="mfg-section">
      <div className="mfg-container">

        {/* ── HEADING ── */}
        <motion.div
          className="mfg-heading-wrap"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
        >
          <motion.span className="mfg-heading-serif" variants={fadeUp}>
            
          </motion.span>
          <motion.h2 className="mfg-heading" variants={fadeUp} transition={{ duration: 0.6, delay: 0.1 }}>
            Electronic <span>Manufacturing Services</span>
          </motion.h2>
          
        </motion.div>

        {/* ── CARDS GRID ── */}
        <div className="mfg-cards-grid">
          {cardData.map((card, i) => (
            <motion.div
              key={card.id}
              className="mfg-card"
              style={{ "--accent": card.accent }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.5, delay: i * 0.1, ease: "easeOut" }}
              onClick={() => handleCardClick(card.slug)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && handleCardClick(card.slug)}
              style={{
                "--accent": card.accent,
                cursor: "pointer",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              whileHover={{ y: -8, boxShadow: "0 12px 24px rgba(0, 0, 0, 0.1)" }}
            >
              {/* Icon + Title */}
              <div className="mfg-icon-row">
                <div className="mfg-icon-box">{card.icon}</div>
                <h3 className="mfg-card-title">
                  {card.title}
                </h3>
              </div>

              {/* Description */}
              <p className="mfg-card-desc">{card.desc}</p>

              {/* Divider */}
              <div className="mfg-divider" />

              {/* CTA */}
              <div className="mfg-cta">
                <span className="mfg-cta-text">Learn More</span>
                <span className="mfg-cta-arrow">→</span>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Manufacturing;